import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { Section } from './Section';
export function RevealSection() {
  return <Section eyebrow="La solución" tone="darker" data-id="element-123" data-mp="3dqrablxxft6r">
      <div className="flex flex-col items-start gap-8 sm:flex-row" data-id="element-124" data-mp="38sg19dfghmpl">
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-shield-500/40 bg-shield-500/10" data-id="element-125" data-mp="38spst5g5g1xe">
          <ShieldIcon className="h-8 w-8 text-shield-500" aria-hidden="true" data-id="element-126" data-mp="5bpswrweixkq" />
        </div>
        <div className="space-y-5 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-127" data-mp="cmv9sir3tms">
          <h2 className="font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-128" data-mp="asace7hc1ip">
            Creé <span className="text-shield-500" data-id="element-129" data-mp="3mk382770ydmm">ESCUDO DIGITAL 2025</span>.
          </h2>
          <p data-id="element-130" data-mp="2g3r75yctihnc">
            No es un libro técnico aburrido de 300 páginas. Es un{' '}
            <span className="font-semibold text-white" data-id="element-131" data-mp="2g1egmwszuyyo">plan de acción rápida</span>: te enseño
            exactamente qué botones tocar y qué configuraciones activar para que, aunque un hacker
            tenga tu contraseña, no pueda entrar a tus cuentas.
          </p>
          <p data-id="element-132" data-mp="2szmqvmgaepxs">
            Es el manual de supervivencia que toda persona con un smartphone en Argentina debería
            tener instalado en su cabeza (y en su teléfono).
          </p>
        </div>
      </div>
    </Section>;
}